<div class="main-content">
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-12">
					<div class="card">
						<div class="card-header card-header-{{color}}">
							<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> Storefront settings</h4>
							<p class="card-category mb-0 storefront-settings-blurb">Configure the dealer-facing storefront: banners, categories, information pages, QR codes, bestsellers, and registration approvals.</p>
						</div>
						<div class="card-body">
							<mat-tab-group #tabPanel mat-align-tabs="start" class="" color="accent">
								<mat-tab label="Banners">
									<ng-template matTabContent>
										<app-banners></app-banners>
									</ng-template>
								</mat-tab>
								<mat-tab label="Categories">
									<ng-template matTabContent>
										<app-categories></app-categories>
									</ng-template>
								</mat-tab>
								<mat-tab label="Modules">
									<ng-template matTabContent>
										<app-modules></app-modules>
									</ng-template>
								</mat-tab>
								<mat-tab label="Customers Awaiting Approval ({{ awaitingApprovalCount || 0 }})">
									<ng-template matTabContent>
										<app-customer-approval (customersawaiting)="updateApprovalCount($event)"></app-customer-approval>
									</ng-template>
								</mat-tab>

								<mat-tab label="Information">
									<ng-template matTabContent>
										<app-information></app-information>
									</ng-template>
								</mat-tab>
								<mat-tab label="Blog">
									<ng-template matTabContent>
										<app-blog></app-blog>
									</ng-template>
								</mat-tab>
								<mat-tab label="QR Codes">
									<ng-template matTabContent>
										<app-qr-codes></app-qr-codes>
									</ng-template>
								</mat-tab>
								<mat-tab label="Customer Searches">
									<ng-template matTabContent>
										<app-customer-web-search></app-customer-web-search>
									</ng-template>
								</mat-tab>
								<mat-tab label="Best Sellers">
									<ng-template matTabContent>
										<app-bestsellers></app-bestsellers>
									</ng-template>
								</mat-tab>
							</mat-tab-group>
						</div>
					</div>
				</div>
			</div>
		</div>
</div>
